import React, { useState } from 'react';
import { CONTACTO_URL } from '../config/api';
import SpinnerImaginaMini from '../componentes/SpinnerImaginaMini';

const Contacto = () => {
  const [form, setForm] = useState({
    nombre: '',
    email: '',
    telefono: '',
    negocio: '',
    profesionales: '',
    servicio: '',
    descripcion: '',
    descubrimiento: ''
  });

  const [mensaje, setMensaje] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [enviadoCorrectamente, setEnviadoCorrectamente] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleServicioClick = (servicioElegido) => {
    setForm({ ...form, servicio: servicioElegido });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensaje('');
    setEnviando(true);

    const camposRequeridos = { ...form };
    delete camposRequeridos.descripcion;
    const campos = Object.values(camposRequeridos);
    if (campos.some(c => c.trim() === '')) {
      alert('Por favor completá todos los campos obligatorios.');
      setEnviando(false);
      return;
    }

    try {
      const res = await fetch(CONTACTO_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });

      if (res.ok) {
        setMensaje('');
        setEnviadoCorrectamente(true);
        setForm({
          nombre: '', email: '', telefono: '',
          negocio: '', profesionales: '',
          servicio: '', descripcion: '', descubrimiento: ''
        });
      } else {
        setMensaje('⚠️ Ocurrió un error al enviar tu consulta. Intentá más tarde.');
      }
    } catch (error) {
      console.error(error);
      setMensaje('❌ Error al conectar con el servidor. Verificá tu conexión.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <>
      <div id="contacto" style={bloqueConFondo}>
        <div style={encabezadoBloque}>
               <h2
                className="text-center mb-2"
                style={{ color: "#FF7A00", fontWeight: "bold" }}
              >
                Completá el formulario y recibí una solución personalizada en minutos.
              </h2> 
        </div>
        {enviadoCorrectamente ? (
          <div style={wrapper}>
            <SpinnerImaginaMini mostrarTexto={false} />
            <p style={{
              fontSize: '18px',
              marginTop: '20px',
              fontWeight: 'bold',
              color: 'green',
              textAlign: 'center'
            }}>
              ✅ ¡Gracias! Vamos a contactarte muy pronto.
            </p>
          </div>
        ) : (
          <div style={wrapper}>
            <h2 style={titulo}>Contanos sobre tu negocio</h2>
            <p style={{ textAlign: 'center', marginBottom: '30px', fontSize: '17px' }}>
              Te contactaremos para ayudarte a configurar tu cuenta gratis de Imagy. 🤝
            </p>

            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              {enviando ? (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '20px 0' }}>
                  <SpinnerImaginaMini />
                </div>
              ) : (
                <>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <label style={{ fontWeight: 'bold', fontSize: '17px' }}>¿Qué servicio te interesa?</label>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <button
                        type="button"
                        style={{
                          ...botonServicio,
                          backgroundColor: form.servicio === 'botImagy' ? '#ffb347' : '#fff'
                        }}
                        onClick={() => handleServicioClick('botImagy')}
                      >
                        Bot Imagy
                      </button>
                      <button
                        type="button"
                        style={{
                          ...botonServicio,
                          backgroundColor: form.servicio === 'diseñoWeb' ? '#ffb347' : '#fff'
                        }}
                        onClick={() => handleServicioClick('diseñoWeb')}
                      >
                        Diseño Web
                      </button>
                    </div>
                  </div>

                  <input name="descubrimiento" type="text" placeholder="¿Cómo nos descubriste?" value={form.descubrimiento} onChange={handleChange} style={input} />

                  <div style={filaInputs}>
                    <input name="nombre" type="text" placeholder="Tu nombre completo" value={form.nombre} onChange={handleChange} style={inputMitad} />
                    <input name="email" type="email" placeholder="Correo electrónico" value={form.email} onChange={handleChange} style={inputMitad} />
                  </div>

                  <div style={filaInputs}>
                    <input name="telefono" type="tel" placeholder="Teléfono" value={form.telefono} onChange={handleChange} style={inputMitad} />
                    <select name="negocio" value={form.negocio} onChange={handleChange} style={inputMitad}>
                      <option value="">¿Qué tipo de negocio tenés?</option>
                      <option value="Veterinaria">Veterinaria</option>
                      <option value="Profesional de la salud">Profesional de la salud</option>
                      <option value="Peluquería">Peluquería</option>
                      <option value="Peluquería canina">Peluquería canina</option>
                      <option value="Cancha de fútbol">Cancha de fútbol</option>
                      <option value="Clínica médica">Clínica médica</option>
                      <option value="Consultorio individual">Consultorio individual</option>
                      <option value="Centro de estética">Centro de estética</option>
                      <option value="Tienda o comercio">Tienda o comercio</option>
                      <option value="Emprendimiento personal">Emprendimiento personal</option>
                      <option value="Otro">Otro</option>
                    </select>
                  </div>

                  <div style={filaInputs}>
                    <select name="profesionales" value={form.profesionales} onChange={handleChange} style={inputMitad}>
                      <option value="">¿Cuántos profesionales atienden?</option>
                      <option value="1">1</option>
                      <option value="2 a 5">2 a 5</option>
                      <option value="6 a 10">6 a 10</option>
                      <option value="Más de 10">Más de 10</option>
                    </select>
                    <div style={{ flex: 1 }}></div>
                  </div>

                  <textarea name="descripcion" rows="3" placeholder="Contanos tu idea o necesidad... (opcional)" value={form.descripcion} onChange={handleChange} style={input} />
                </>
              )}

              <button type="submit" style={{ ...boton, opacity: enviando ? 0.6 : 1 }} disabled={enviando}>
                {enviando ? 'Enviando...' : '¡ENVIAR CONSULTA! →'}
              </button>

              {mensaje && (
                <p style={{
                  textAlign: 'center',
                  marginTop: '10px',
                  color: mensaje.includes('✅') ? 'green' : 'red'
                }}>
                  {mensaje}
                </p>
              )}
            </form>
          </div>
        )}
      </div>

      <p style={{
        textAlign: 'center',
        marginTop: '5px',
        fontSize: '16px',
        color: '#555',
        fontStyle: 'italic'
      }}>
        📢 ¡Tu equipo merece trabajar con menos estrés y más sonrisas!
      </p>
    </>
  );
};

const encabezadoBloque = {
  maxWidth: '800px',
  margin: '30px auto 30px',
  textAlign: 'center'
};

const wrapper = {
  maxWidth: '1300px',
  width: '100%',
  margin: '0 auto 80px',
  padding: '40px 30px',
  backgroundColor: '#fff',
  borderRadius: '20px',
  boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
};

const titulo = {
  textAlign: 'center',
  color: '#333',
  fontWeight: 'bold',
  fontSize: '26px',
  marginBottom: '10px'
};

const input = {
  padding: '16px',
  borderRadius: '12px',
  border: '1px solid #ccc',
  fontSize: '18px',
  width: '100%'
};

const inputMitad = {
  ...input,
  flex: 1,
  minWidth: '300px'
};

const filaInputs = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '20px'
};

const boton = {
  padding: '15px',
  border: 'none',
  borderRadius: '30px',
  backgroundImage: 'linear-gradient(to right, #007bff, #00c6ff)',
  color: '#fff',
  fontWeight: 'bold',
  fontSize: '16px',
  cursor: 'pointer',
  transition: 'background 0.3s ease'
};

const botonServicio = {
  flex: 1,
  padding: '12px',
  border: '1px solid #ccc',
  borderRadius: '10px',
  fontWeight: 'bold',
  fontSize: '16px',
  cursor: 'pointer',
  transition: '0.2s ease'
};

const bloqueConFondo = {
  background: "linear-gradient(135deg, #FFA500 0%, #FFE0B2 100%)",
  padding: '10px 20px 60px 20px'
};

export default Contacto;
